/**
 * Audited recurring-message consent contract shared by every web opt-in surface.
 *
 * Bump this version WHENEVER the user-visible opt-in copy changes (rule 83 —
 * the recorded version must identify exactly what the seeker agreed to). The
 * backend `ContactRequest.consent_copy_version` Literal must accept the new
 * value in the same change, and `contact_capture._CONSENT_COPY_CHANNELS` must
 * map it to exactly the channels this copy names; older versions stay accepted
 * for in-flight clients.
 *
 * v3 (2026-07-29): names WhatsApp AND email — hence the dropped `whatsapp_`
 * prefix on both the constant and the value. v2 asked for WhatsApp alone, which
 * was lawful but silently stopped feeding the FREE channel: from 2026-07-16
 * every new opt-in registered WhatsApp only (~Rs0.78/msg) while email consent
 * fell to ~0/week and the owned free-reachable base froze at 27,412 (rule 89).
 * A daily loop has to run on a free channel, so the copy now asks for one.
 *
 * v3 covers one agreement in two languages: the English copy and its Hindi
 * rendering. From 2026-10-29 the Hindi rendering is written in Devanagari
 * (lib/marketing-consent-copy-hi.ts; owner rule "Hindi UI = Devanagari"), word
 * for word the Roman Hindi it replaced, same channels, so the version stays v3.
 *
 * v2 (2026-07-15): relationship/continuity framing — "Aapka AI Jyotishi will
 * remember this kundali" — replacing the generic "useful Jyotish updates" v1.
 */
export const MARKETING_CONSENT_COPY_VERSION = "jyotish_updates_v3";
